export class TextBlockDetails {
    public textFormatting: string[];
    public align: number;
    public fontType: number;
    public fontSize: number;
    public textLines: string[];
    public imagePath?: string;
    public width?: number;
    public height?: number;
    public barcode_type?: string;
    public textPosition?: string;
    public value?: string;
    public justification?: string;

    constructor(
        textFormatting: string[], 
        align: number, 
        fontType: number, 
        fontSize: number, 
        textLines: string[], 
    ) {
        this.textFormatting = textFormatting;
        this.align = align;
        this.fontType = fontType;
        this.fontSize = fontSize;
        this.textLines = textLines;
    }
}